import sanitizeHtml from 'sanitize-html';

export const sanitizeTelegramHtml = (html: string): string => {
  return sanitizeHtml(html, {
    allowedTags: ['b', 'strong', 'i', 'em', 'u', 's', 'a', 'code', 'pre'],
    allowedAttributes: {
      a: ['href'],
    },
    allowedSchemes: ['http', 'https', 'mailto'],
    transformTags: {
      strong: 'b',
      em: 'i',
    },
  });
};
